import { UpdateAccountServerErrors } from 'hooks/useUpdateAccountHandler'
import { Alert } from '@cmsgov/ds-medicare-gov'

export interface UpdateAccountModalErrorsProps {
  serverErrors: UpdateAccountServerErrors,
  basicErrorText: string,
  invalidCriteriaErrorText: string
}

export const UpdateAccountModalErrors: React.FC<UpdateAccountModalErrorsProps> = ({
  serverErrors,
  invalidCriteriaErrorText,
  basicErrorText
}) => {
  return (
    <>
      {serverErrors.basic && (
        <Alert className='my-u-mt--8' variation='error' role='alert'>
          {basicErrorText}
        </Alert>
      )}
      {serverErrors.invalidCriteria && (
        <Alert className='my-u-mt--8' variation='error' role='alert'>
          {invalidCriteriaErrorText}
        </Alert>
      )}
    </>
  )
}
